/**
 * Standard pieces of information that each landing page includes.
 */
export default [
  {
    id: 0,
    component: 'Home',
    name: '',
    title: 'Home',
    description: 'Welcome to the RI DMV reservation system.'
  },
  {
    id: 1,
    component: 'TypeSelection',
    name: 'Type of reservation',
    title: 'Select the type of reservation',
    description: 'You can take care of multiple transactions with only one reservation. ' +
      'If you need to take care of more than one transaction, and one of them is Adjudication ' +
      'or a CDL please make that your primary reservation in the drop-down below.'
  },
  {
    id: 2,
    component: 'SlotSelection',
    name: 'Date and time',
    title: 'Select a date and time',
    description: 'Reservations are added throughout the week. Please check back regularly for additional availability.'
  },
  {
    id: 3,
    component: 'UserInformation',
    name: 'Your information',
    title: 'Enter your information',
    description: 'Please enter the information for the customer who needs to do a transaction with the RI DMV.'
  },
  {
    id: 4,
    component: 'Confirmation',
    name: 'Confirm reservation',
    title: 'Confirm your reservation',
    description: 'Your appointment is not quite done. Please read and confirm the details below.'
  },
  {
    id: 5,
    component: 'ReservationFinal',
    name: 'Reservation confirmation',
    title: 'View your reservation confirmation',
    description: '<p>Please be sure to print or save your confirmation number for check-in.</p>' +
      '<p class="app-no-print">By the way, you don\'t have to make a new reservation if you have multiple transactions. ' +
      'If one of those transactions is an Adjudication or a CDL and you\'ve made that the primary transaction we can ' +
      'take care of any of your other needs with this one reservation.</p>',
    descriptionwithtoken: '<p>Please be sure to print or save your confirmation number for check-in. <span>Please log in again to see your updated reservation details on your customer portal profile page.</span></p>' +
      '<p class="app-no-print">By the way, you don\'t have to make a new reservation if you have multiple transactions. ' +
      'If one of those transactions is an Adjudication or a CDL and you\'ve made that the primary transaction we can ' +
      'take care of any of your other needs with this one reservation.</p>'
  },
  {
    id: 6,
    component: 'Lookup',
    name: 'Look up your reservation',
    title: 'Look up your reservation',
    description: 'Enter the confirmation code that was provided to you when you made your reservation. ' +
      'If you gave us an email address or phone number, the confirmation code was also sent to you at that time. ' +
      'If you don’t have your confirmation code, please enter either your email address or phone number.'
  },
  {
    id: 7,
    component: 'LookupAlt',
    name: 'No reservation found',
    title: 'No reservation found',
    description: 'There is no reservation matching the information you entered. Would you like to try again?'
  },
  {
    id: 8,
    component: 'Modification',
    name: 'View reservations',
    title: 'View reservation(s)',
    description: 'If you need to change your location, or date and time, click on the Modify button. ' +
      'You will be shown current reservation availability based on your new choices. If you are unable to find ' +
      'a reservation that works for your needs, you will be given the chance to keep your existing reservation. ' +
      'If you simply need to cancel your existing reservation, click the Cancel reservation button below.'
  },
  {
    id: 9,
    component: 'ModificationAlt',
    name: 'Your reservation has been cancelled',
    title: 'Your reservation has been cancelled',
    description: 'Thank you for taking the time to let us know you will not be coming in. ' +
      'We look forward to seeing you at your next visit.'
  },
  {
    id: 10,
    component: 'Payment',
    name: 'Payment information',
    title: 'Enter your payment information',
    description: 'Please enter the information for the customer who needs to do a transaction with the RI DMV.'
  }
];
